import { Box, Link } from '@chakra-ui/react'
import React from 'react'

export default function Feature() {
    return (
        <Box fontSize="lg" fontWeight="500"  lineHeight="50px">

            <Link>Bestsellers</Link>
            <br />
            <Link>Under 149 store</Link>
            <br />
            <Link>Quick Bites</Link>
            <br />
            <Link>Biriyani Speacial</Link>

        </Box>
    )
}
